
(function(){
  // sticky buy bar
  var bar = document.querySelector('.js-sticky-bar');
  if(bar){
    window.addEventListener('scroll', function(){
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      bar.classList.toggle('show', y > 820);
    }, {passive:true});
  }

  // gallery thumb swap
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        var img = t.querySelector('img');
        if(main && img){ main.src = img.src; main.alt = img.alt; }
      });
    });
  });

  // variant selection
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var dataEl = document.getElementById(form.getAttribute('data-variants'));
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-price="'+form.getAttribute('data-section')+'"]');
    var submit = form.querySelector('[data-add]');
    var moneyFmt = form.getAttribute('data-money') || '${{amount}}';

    function money(cents){
      var v = (cents/100).toFixed(2);
      return moneyFmt.replace('{{amount}}', v).replace('{{amount_no_decimals}}', Math.round(cents/100));
    }
    function selectedOptions(){
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-option-index'),10);
        var checked = group.querySelector('input:checked');
        if(checked) opts[idx] = checked.value;
      });
      return opts;
    }
    function findVariant(opts){
      return variants.find(function(v){
        return v.options.every(function(o,i){ return o === opts[i]; });
      });
    }
    function refreshSelectedClass(){
      form.querySelectorAll('.opt').forEach(function(l){
        var inp = l.querySelector('input');
        l.classList.toggle('selected', inp && inp.checked);
      });
    }
    function swapImage(v){
      if(!v || !v.featured_image || !v.featured_image.src) return;
      document.querySelectorAll('[data-gallery-main] img').forEach(function(gm){
        gm.src = v.featured_image.src;
        gm.alt = v.featured_image.alt || gm.alt;
      });
    }
    function update(){
      refreshSelectedClass();
      var v = findVariant(selectedOptions());
      if(!v){
        if(submit){submit.disabled=true;submit.textContent='Unavailable';}
        return;
      }
      if(idInput) idInput.value = v.id;
      swapImage(v);
      priceEls.forEach(function(el){ el.innerHTML = money(v.price); });
      if(submit){
        submit.disabled = !v.available;
        submit.textContent = v.available ? ('Add to cart — ' + money(v.price)) : 'Sold out';
      }
      // reflect in sticky bar labels sharing this section
      document.querySelectorAll('[data-add-label="'+form.getAttribute('data-section')+'"]').forEach(function(el){
        el.textContent = v.available ? ('Add to cart — ' + money(v.price)) : 'Sold out';
      });
    }
    form.querySelectorAll('input[type=radio]').forEach(function(r){ r.addEventListener('change', update); });
    update();

    // AJAX add to cart with toast
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(form);
      submit && (submit.disabled = true);
      fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(){
          showToast();
          submit && (submit.disabled = false);
        })
        .catch(function(){ form.submit(); });
    });
  });

  // sticky-bar add buttons that just scroll to form / trigger
  document.querySelectorAll('[data-sticky-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var form = document.querySelector('[data-product-form]');
      if(form) form.requestSubmit ? form.requestSubmit() : form.querySelector('[data-add]').click();
    });
  });

  var toastEl;
  function showToast(){
    if(!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.textContent = 'Added to cart ✓';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function(){ toastEl.classList.remove('show'); }, 2200);
  }
})();
